<template>
  <v-container class="mb-0 pb-0">
    <v-card class="ps-2 pt-1 pe-2">
      <v-alert
        prominent
        dense
        text
        type="error"
        class="pa-2"
        dismissible
        border="left"
        v-if="!isRegistartionDone"
      >
        <v-row align="center">
          <v-col class="grow">
            {{ !isRegistartionDone ? $t("isUserRegistered") : null
            }}<v-btn
              color="primary"
              @click="
                $router.push(
                  registeruserType === 'IND'
                    ? '/add-indivisual-user'
                    : registeruserType === 'BUS'
                    ? '/business-user-info'
                    : ''
                )
              "
              text
              ><v-icon>mdi-account-plus</v-icon>
              {{ $t("register_label") }}</v-btn
            >
          </v-col>
          <!-- <v-col class="shrink"> </v-col> -->
        </v-row>
      </v-alert>
      <v-alert
        prominent
        dense
        text
        type="error"
        class="pa-2"
        dismissible
        border="left"
        v-if="!iskycdone && isRegistartionDone"
      >
        <v-row align="center">
          <v-col class="grow">
            {{ !iskycdone ? $t("kyccopleteError") : null
            }}<v-btn small color="primary" @click="$router.push('/kyc')" text
              ><v-icon small>mdi-shield-check</v-icon
              >{{ $t("click_here_label") }}</v-btn
            >
          </v-col>
          <!-- <v-col class="shrink" cols="2" md="3"> </v-col> -->
        </v-row>
      </v-alert>
      <v-alert
        v-if="alertMsg.status"
        dense
        :value="alertMsg.status"
        :key="alertMsg.key"
        id="alert"
        :color="alertMsg.color"
        :type="alertMsg.type"
        dismissible
      >
        {{ alertMsg.text }}
      </v-alert>
      <loading
        :active="Loadsendmoney"
        :is-full-page="false"
        :opacity="1"
        color="#ff6b00"
      />
      <v-card class="mt-0 mb-0 pa-4 pb-1 main-card" rounded="lg" elevation="5">
        <p
          v-if="is_partner"
          class="p-0 m-0 grey--text font-weight-bold text-caption"
        >
          <v-icon small class="mb-1">mdi-information-outline</v-icon>
          {{ $t("transaction_amount_exceed_limit") }}
        </p>
        <v-col cols="12" lg="3" sm="6" xs="12">
          <v-btn-toggle
            x-small
            v-model="user_type_toggele"
            rounded
            color="secondary"
            mandatory
          >
            <v-btn small @click="reload_byusertype('IND')"> Individual </v-btn>
            <v-btn small @click="reload_byusertype('BUS')">Business </v-btn>
          </v-btn-toggle>
        </v-col>
        <v-form ref="amountsection" lazy-validation>
          <v-row class="amountsection" no-gutters>
            <v-col cols="12" md="5" sm="12">
              <div class="form-inputs w-100 px-0">
                <label for="sendAmount" class="mb-0 custome-label-text">
                  Sending Amount
                  <span style="color: #f00">*</span>
                </label>

                <v-text-field
                  type="number"
                  hide-spin-buttons
                  outlined
                  rounded
                  :rules="is_partner ? EvoletAmtValidation : sendAmtValidation"
                  id="sendAmount"
                  v-model="amountSection.sendAmount"
                  :hint="base_courency_hint"
                  persistent-hint
                  color="primary"
                  required
                  class="custome-text-field"
                  @keyup.prevent="
                    debounceExchangeFee('C', amountSection.sendAmount, '', false)
                  "
                >
                  <template v-slot:prepend-inner class="pt-0">
                    <country-flag country="my" class="mb-0" />
                    <span class="m-2 me-6">MYR</span>
                  </template>

                  <template v-slot:append>
                    <img
                      width="24"
                      height="24"
                      class="me-2"
                      src="@/assets/give-money-hand_down.svg"
                    />
                  </template>
                </v-text-field>
              </div>
            </v-col>

            <v-col cols="12" md="5" sm="12">
              <div class="form-inputs w-100" rounded="lg">
                <label for="ReceivingAmount" class="mb-0 custome-label-text">
                  Receive Amount
                  <span style="color: #f00">*</span>
                </label>
                <v-text-field
                  type="number"
                  hide-spin-buttons
                  outlined
                  :rules="reciveAmtValidation"
                  :hint="target_currency_hint"
                  persistent-hint
                  color="primary"
                  class="custome-text-field"
                  @keyup.prevent="
                    debounceExchangeFee(
                      'P',
                      '',
                      amountSection.receiveAmount,
                      true
                    )
                  "
                  v-model="amountSection.receiveAmount"
                >
                  <template v-slot:prepend-inner>
                    <country-flag :country="selected_flag" class="mb-0" />
                    <v-select
                      :items="country_list"
                      :label="target_currency"
                      :menu-props="{ bottom: true, offsetY: true }"
                      v-model="selected_country"
                      solo
                      flat
                      class="custome-text custome-slect-prepend"
                      style="width: 70px; height: 33px; margin-bottom: 15px"
                    >
                      <template v-slot:item="data">
                        <template class="border">
                          <country-flag
                            :country="data.item.avatar"
                            class="m-0"
                          />
                          <v-list-item-content>
                            <v-list-item-title
                              v-html="data.item.text + ' ' + data.item.name"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </template>
                    </v-select>
                  </template>
                  <template v-slot:append>
                    <img
                      width="24"
                      height="24"
                      class="me-2"
                      src="@/assets/receive-money-flat_hand.svg"
                    />
                  </template>
                </v-text-field>
              </div>
            </v-col>
            <v-col cols="12" md="2" sm="12">
              <div class="form-inputs w-100 px-0">
                <label for="PaymentMode" class="mb-0 custome-label-text">
                  Payment Mode
                  <span style="color: #f00">*</span>
                </label>

                <v-select
                  id="PaymentMode"
                  class="custome-text-field"
                  :menu-props="{ bottom: true, offsetY: true }"
                  :items="paymentList"
                  item-text="value"
                  item-value="data"
                  :rules="paymentMode"
                  :hint="payment_mode_hint"
                  @change="getpaymode(amountSection.paymentMode)"
                  persistent-hint
                  outlined
                  required
                  v-model="amountSection.paymentMode"
                ></v-select>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-card>

      <v-row class="apex-div">
        <v-col cols="12" md="6" sm="12" class="order-last order-md-first">
          <v-card class="pa-5 main-card" rounded="lg" elevation="5">
            <v-row no-gutters>
              <v-col lg="6" sm="6">
                <label class="v-grap-text"> Exchange Rate </label>
              </v-col>
              <v-col lg="6" sm="6">
                <v-row no-gutters class="align-items-center">
                  <span class="mr-3 mb-0 grap-flag-div">
                    <country-flag :country="selected_flag" />
                    <span class="v-grap-text ml-2 grap-flag-subdiv">{{
                      target_currency
                    }}</span>
                  </span>
                  <span
                    class="v-grap-text v-grap-v-btn active-btn grap-btn"
                    id="one week"
                    >1W</span
                  >
                </v-row>
              </v-col>
            </v-row>
            <apexchart
              type="area"
              height="243"
              ref="chart"
              :key="isKey"
              :options="chartOptions"
              :series="series"
            ></apexchart>
          </v-card>
        </v-col>
        <v-col cols="12" md="6" sm="12">
          <loading
            :active="isTransSummary"
            :is-full-page="false"
            :opacity="0.7"
            color="#ff6b00"
          />
          <v-card
            class="v-transaction-card"
            rounded="lg"
            elevation="5"
            height="94%"
          >
            <v-card-title class="card-heading">
              <label> Summary</label>
            </v-card-title>
            <v-row class="px-6 mb-2 mt-2 custome-text">
              <v-col
                cols="6"
                class="pl-2 m-0 fixed-height-div d-flex align-items-center text-end"
              >
                <v-row no-gutters>
                  <v-col lg="11" sm="8">
                    <h6>Collected Amount</h6>
                  </v-col>
                  <div class="rounded-circle v-custome-icon">
                    <v-icon>mdi-equal</v-icon>
                  </div>
                </v-row>
              </v-col>
              <v-col
                cols="6"
                class="pl-2 m-0 d-flex justify-content-end align-items-center"
              >
                <h6 class="ellipsis">
                  {{
                    Number(
                      +Number(exchangeData.collectAmount || 0).toFixed(2)
                    ).toLocaleString()
                  }}
                </h6>
                <h6 class="ml-2">{{ base_currency }}</h6>
                <img
                  class="ml-2 mb-1 extra_space"
                  width="18"
                  height="18"
                  src="@/assets/give-money-hand_down.svg"
                />
                <v-col lg="2" class="extra_space"> </v-col>
              </v-col>

              <v-col
                cols="6"
                class="pl-2 m-0 fixed-height-div d-flex align-items-center text-end"
              >
                <v-row no-gutters>
                  <v-col lg="11" sm="8">
                    <h6>Fee</h6>
                  </v-col>
                  <div class="rounded-circle v-custome-icon">
                    <v-icon>mdi-minus</v-icon>
                  </div>
                </v-row>
              </v-col>
              <v-col
                cols="6"
                class="pl-2 m-0 d-flex fixed-height-div justify-content-end align-items-center"
              >
                <h6 class="ellipsis">
                  {{
                    Number(
                      +Number(
                        (exchangeData && exchangeData.serviceCharge) || 0
                      ).toFixed(2)
                    ).toLocaleString()
                  }}
                </h6>
                <h6 class="ml-2">{{ base_currency }}</h6>
                <p class="ml-2 border-none fixed-width" />
                <v-col lg="2" sm="0" class="extra_space"> </v-col>
              </v-col>

              <v-col
                cols="6"
                class="pl-2 m-0 fixed-height-div d-flex align-items-center text-end"
              >
                <v-row no-gutters>
                  <v-col lg="11" sm="8">
                    <h6>Transfer Amount</h6>
                  </v-col>
                  <div class="rounded-circle v-custome-icon">
                    <v-icon>mdi-equal</v-icon>
                  </div>
                </v-row>
              </v-col>
              <v-col
                cols="6"
                class="pl-2 m-0 d-flex fixed-height-div justify-content-end align-items-center"
              >
                <h6 class="ellipsis">
                  {{
                    Number(
                      +Number(exchangeData.transferAmount || 0).toFixed(2)
                    ).toLocaleString()
                  }}
                </h6>
                <h6 class="ml-2">{{ base_currency }}</h6>
                <p class="ml-2 border-none fixed-width" />
                <v-col lg="2" sm="0" class="extra_space"> </v-col>
              </v-col>

              <v-col
                cols="6"
                class="pl-2 m-0 fixed-height-div d-flex align-items-center text-end"
              >
                <v-row no-gutters>
                  <v-col lg="11" sm="8">
                    <h6 class="d-flex justify-content-end">
                      Guaranted Rate (1{{ base_currency }})
                    </h6>
                  </v-col>
                  <div class="rounded-circle v-custome-icon">
                    <v-icon>mdi-close</v-icon>
                  </div>
                </v-row>
              </v-col>
              <v-col
                cols="6"
                class="pl-2 m-0 d-flex fixed-height-div justify-content-end align-items-center"
              >
                <h6 class="ellipsis">
                  {{
                    Number(
                      +Number(exchangeData.exchangeRate || 0).toFixed(2)
                    ).toLocaleString()
                  }}
                </h6>
                <h6 class="ml-2">{{ target_currency }}</h6>
                <p class="ml-2 border-none fixed-width" />
                <v-col lg="2" sm="0" class="extra_space"> </v-col>
              </v-col>
              <v-col
                cols="6"
                class="pl-2 m-0 fixed-height-div d-flex align-items-center text-end"
              >
                <v-row no-gutters>
                  <v-col lg="11" sm="8">
                    <h6>Receive Amount</h6>
                  </v-col>
                  <div class="rounded-circle v-custome-icon">
                    <v-icon>mdi-equal</v-icon>
                  </div>
                </v-row>
              </v-col>
              <v-col
                cols="6"
                class="pl-2 m-0 d-flex justify-content-end align-items-center"
              >
                <h6 class="ellipsis">
                  {{
                    Number(
                      +Number(exchangeData.payoutAmount || 0).toFixed(2)
                    ).toLocaleString()
                  }}
                </h6>
                <h6 class="ml-2">{{ target_currency }}</h6>
                <img
                  class="ml-2 mb-3 extra_space"
                  width="18"
                  height="18"
                  src="@/assets/receive-money-flat_hand.svg"
                />
                <v-col lg="2" sm="0" class="extra_space"> </v-col>
              </v-col>

              <label
                class="light-gray mb-1"
                style="font-size: 12px !important; font-weight: 700"
                >* Rate Text
                {{ new Date().toLocaleString() }}
              </label>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog
        v-model="issendlimit"
        persistent
        :max-width="mobilebreakdown() ? '400' : '90%'"
      >
        <v-card class="pa-3">
          <v-card-text class="d-flex p-0">
            <div class="font">
              {{ $t("txn_not_allowed_label") }}
            </div>
          </v-card-text>
          <v-card-actions class="p-0">
            <v-spacer></v-spacer>
            <v-btn color="orange darken-1" text @click="issendlimit = false">
              ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-container>
</template>

<script>
import Loading from "vue-loading-overlay";
import { required } from "vuelidate/lib/validators";
import { validations } from "@/utils/validation";
import { getspecifiedDate } from "@/utils/UsersList.js";
import { mobilebreakdown, webbreakdown } from "../../utils/breakpoints";
import { mapState } from "vuex";
import commonService from "@/services/AgentCommonService/commonService.js";
// import { eventBus } from "../../../plugins/eventBus";
const {
  sendAmtValidation,
  reciveAmtValidation,
  paymentMode,
  EvoletAmtValidation,
} = validations;
export default {
  data() {
    return {
      mobilebreakdown,
      webbreakdown,
      issendlimit: false,
      isRegistartionDone: true,
      registeruserType: "",
      iskycdone: true,
      valid: true,
      user_type_toggele: null,
      selected_user_Type: "IND",
      alertMsg: {
        status: false,
        timeout: "",
        color: "",
        type: "",
        key: Date.now(),
      },
      bpjsDialog: false,
      policy_number: "",
      isTransSummary: false,
      Loadsendmoney: false,
      selected_service_charge: {},
      steperCal: 1,
      exchange_rate: [],
      series: [
        {
          name: "Rate",
          data: [],
        },
      ],
      no_of_days: 7,
      chartOptions: {
        chart: {
          title: "Exchange Rates",
          id: "exchange-rate",
          type: "area",
          height: 350,
          zoom: {
            autoScaleYaxis: true,
          },
        },
        colors: ["#ff6b00"],
        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 0,
          style: "hollow",
          showNullDataPoints: true,
        },
        yaxis: {
          labels: {
            formatter: (value) => {
              return `${parseFloat(value).toFixed(2)} ${this.target_currency}`;
            },
          },
        },
        xaxis: {
          type: "datetime",
          tickAmount: 6,
        },
        tooltip: {
          x: {
            format: "dd-MM-yyyy",
          },
        },
      },

      sendAmtValidation,
      reciveAmtValidation,
      paymentMode,
      EvoletAmtValidation,
      paymentList: [],
      country_list: [],
      select: null,
      target_currency: "",
      base_currency: "",
      amountSection: {
        sendAmount: "100",
        paymentMode: {},
        receiveAmount: "",
        finalSendAmount: "",
      },
      convertData: {},
      isKey: 1,
      s_amount: "",

      country_obj: [],
      recieving_cntry: "",

      selected_country: {},
      selected_flag: "",
      Skipreciepient: null,
      BenePaymode: "",
      exchangeData: {},
      selectedCountryDetails: {},
      is_partner: false,
      cal_by: "",
      country_info: {},
      exchangeRateDebounceTimer: null,
      policy_rules: [(v) => !!v || "Policy Number is Required."],
    };
  },
  components: {
    Loading,
  },
  validations: {
    amountSection: {
      // sendAmount: { required },
      paymentMode: { required },
      // receiveAmount: { required }
    },
  },
  mounted() {
    this.country_info = JSON.parse(sessionStorage.getItem("partner_country"));
    this.base_currency = this.country_info.currency_code;
    this.getCountryList();
    this.getCountryExchangeRate();
  },
  beforeDestroy() {
    clearTimeout(this.exchangeRateDebounceTimer);
  },
  props: {
    transactionDetails: Object,
  },

  watch: {
    //to get the flag for the selected country
    selected_country(val) {
      let selctedcurrency = val.text ? val.text : val;
      console.log("selected_country", selctedcurrency);
      console.log("country_obj", this.country_obj);
      const country = this.country_list.find(
        (item) => item.text === selctedcurrency
      );

      if (country) {
        console.log("test cur", country);
        this.selected_flag = country.avatar;
        this.recieving_cntry = country.avatar;
        this.selectedCountryDetails = {
          text: country.text,
          name: country.name,
          avatar: country.avatar,
          country_code: country.avatar,
        };

        if (this.isSameSendingAndReceivingCountry(country.avatar)) {
          this.resetExchangeRateSelection();
          this.alertMsg = {
            status: true,
            text:
              "Sending and receiving countries cannot be the same. Please select a different receiving country.",
            color: "warning",
            type: "warning",
            timeout: 2,
            key: Date.now(),
          };
          return;
        }

        this.getExchangeRate(country.avatar);
        this.getPaymentMode(country.avatar);
      }
      this.country_obj.map((country) => {
        if (country.receiverCurrency === selctedcurrency) {
          console.log(this.selectedCountryDetails.avatar);
          console.log("selcted country data", country);
          this.convertData.exchange_rate = country.exchangeRate;
          this.target_currency = country.receiverCurrency;
        }
      });
    },

    "amountSection.paymentMode"(val) {
      if (val === "A") {
        this.openBpjsDialog();
      }
      if (val) {
        console.log("this.selected_country", this.selected_country);
      }
    },

    transactionDetails(val) {
      console.log("test data", val);
      if (val.target_currency) {
        if (val.amountSection) this.amountSection = { ...val.amountSection };
        if (val.target_currency) this.target_currency = val.target_currency;
        if (val.base_currency) this.base_currency = val.base_currency;
        if (val.convertData) this.convertData = val.convertData;
        if (val.selected_service_charge)
          this.selected_service_charge = val.selected_service_charge;
      }
    },

    "alertMsg.status"(new_val) {
      if (new_val) {
        setTimeout(() => {
          this.alertMsg.status = false;
        }, 3000);
      }
    },
  },
  computed: {
    ...mapState(["userDetails"]),
    payment_mode_hint() {
      console.log(
        this.exchangeData && this.exchangeData.serviceCharge
          ? `${this.$t("fee")} = ${this.exchangeData.serviceCharge} MYR`
          : ""
      );
      return this.exchangeData && this.exchangeData.serviceCharge
        ? `${this.$t("fee")} = ${this.exchangeData.serviceCharge} MYR`
        : "";
    },
    base_courency_hint() {
      return this.convertData.exchangeRate
        ? `1 ${this.base_currency} = ${this.convertData.exchangeRate} ${this.target_currency}`
        : "";
    },
    target_currency_hint() {
      return this.amountSection.finalSendAmount
        ? `${this.$t("converting")} = ${this.amountSection.finalSendAmount} MYR`
        : "";
    },
  },
  methods: {
    isSameSendingAndReceivingCountry(receivingCountry) {
      const sendingCountry = this.country_info && this.country_info.iso_alpha3;
      return (
        typeof sendingCountry === "string" &&
        typeof receivingCountry === "string" &&
        sendingCountry.toUpperCase() === receivingCountry.toUpperCase()
      );
    },
    resetExchangeRateSelection() {
      clearTimeout(this.exchangeRateDebounceTimer);
      this.exchangeRateDebounceTimer = null;
      this.Loadsendmoney = false;
      this.isTransSummary = false;
      this.paymentList = [];
      this.amountSection.paymentMode = {};
      this.amountSection.receiveAmount = "";
      this.amountSection.finalSendAmount = "";
      this.convertData = {};
      this.exchangeData = {};
      this.cal_by = "";
    },
    getPaymentModeValue() {
      const paymentMode = this.amountSection.paymentMode;
      if (typeof paymentMode === "string") {
        return paymentMode.trim();
      }
      const paymentModeCode = paymentMode && paymentMode.data;
      return typeof paymentModeCode === "string" ||
        typeof paymentModeCode === "number"
        ? String(paymentModeCode).trim()
        : "";
    },
    canRequestExchangeRate() {
      if (this.isSameSendingAndReceivingCountry(this.recieving_cntry)) {
        this.isTransSummary = false;
        return false;
      }
      return Boolean(this.getPaymentModeValue());
    },
    getTransferAmount(Amount, recievieAmount) {
      return Amount !== "" && Amount !== null && Amount !== undefined
        ? Amount
        : recievieAmount;
    },
    isExchangeRateAmountValid(Amount, recievieAmount) {
      const transferAmount = Number(
        this.getTransferAmount(Amount, recievieAmount)
      );
      return Number.isFinite(transferAmount) && transferAmount > 10;
    },
    debounceExchangeFee(ExchangeType, Amount, recievieAmount, isReverse) {
      clearTimeout(this.exchangeRateDebounceTimer);

      if (!this.isExchangeRateAmountValid(Amount, recievieAmount)) {
        this.exchangeRateDebounceTimer = null;
        this.isTransSummary = false;
        return;
      }

      this.exchangeRateDebounceTimer = setTimeout(() => {
        this.exchangeRateDebounceTimer = null;
        if (isReverse) {
          this.getExchangefeeReverse(ExchangeType, Amount, recievieAmount);
        } else {
          this.getExchangefee(ExchangeType, Amount, recievieAmount);
        }
      }, 500);
    },
    reload_byusertype(val) {
      this.selected_user_Type = val;
      this.getCountryExchangeRate();
      this.getExchangefee("C", this.amountSection.sendAmount, "");
    },
    //using to get the transaction summary
    async getExchangefee(ExchangeType, Amount, recievieAmount) {
      this.alertMsg.status = false;
      if (!this.isExchangeRateAmountValid(Amount, recievieAmount)) {
        this.isTransSummary = false;
        return;
      }
      if (!this.canRequestExchangeRate()) {
        return;
      }
      if (!this.Loadsendmoney) {
        this.isTransSummary = true;
      }

      try {
        const data = {
          transfer_amount: this.getTransferAmount(Amount, recievieAmount),
          payout_currency: this.selected_country.text
            ? this.selected_country.text
            : this.selected_country,
          location_id: "",
          payment_mode: this.getPaymentModeValue(),
          payout_country: this.recieving_cntry,
          send_country: this.country_info.iso_alpha3,
          send_currency: this.country_info.currency_code,
          send_partner: sessionStorage.getItem("partner_id"),
          calc_by: ExchangeType,
          user_type: this.selected_user_Type,
        };
        const responseData = await commonService.getExchangeRates(data);
        console.log("exchange rate", responseData.data);
        if (responseData.data.status_code === 200) {
          this.cal_by = "C";
          this.convertData = responseData.data.data[0];
          console.log("convertData", this.convertData.payoutAmount);
          this.amountSection.finalSendAmount = parseFloat(
            this.convertData.transferAmount
          ).toFixed(2);
          this.amountSection.receiveAmount = parseFloat(
            this.convertData.payoutAmount
          ).toFixed(2);

          this.isTransSummary = false;
          this.exchangeData = responseData.data.data[0];
        } else {
          this.cal_by = "";
          console.log("Evolet Send", this.amountSection.sendAmount);
          this.isTransSummary = false;
          this.exchangeData = [];
          this.amountSection.sendAmount = "";
          if (!this.is_partner) {
            this.alertMsg = {
              status: true,
              text:
                responseData.data.status_code +
                ": " +
                responseData.data.message,
              color: "warning",
              type: "warning",
              timeout: 2,
              key: Date.now(),
            };
          }
        }
      } catch (e) {
        console.log("Evolet Send", this.amountSection.sendAmount);
        this.cal_by = "";
        if (!this.is_partner) {
          this.alertMsg = {
            status: true,
            text: "Entered amount is not support to proceed transaction.",
            color: "warning",
            type: "warning",
            timeout: 2,
            key: Date.now(),
          };
        }
        this.isTransSummary = false;
        this.amountSection.sendAmount = "";

        console.log(e);
        this.exchangeData = [];
        this.amountSection.receiveAmount = 0;
      }
    },
    async getExchangefeeReverse(ExchangeType, Amount, recievieAmount) {
      this.alertMsg.status = false;
      if (!this.isExchangeRateAmountValid(Amount, recievieAmount)) {
        this.isTransSummary = false;
        return;
      }
      if (!this.canRequestExchangeRate()) {
        return;
      }
      if (!this.Loadsendmoney) {
        this.isTransSummary = true;
      }
      try {
        const data = {
          transfer_amount: this.getTransferAmount(Amount, recievieAmount),
          payout_currency: this.selected_country.text
            ? this.selected_country.text
            : this.selected_country,
          location_id: "",
          payment_mode: this.getPaymentModeValue(),
          payout_country: this.recieving_cntry,
          send_country: this.country_info.iso_alpha3,
          send_currency: this.country_info.currency_code,
          send_partner: sessionStorage.getItem("partner_id"),
          calc_by: ExchangeType,
          user_type: this.selected_user_Type,
        };
        const responseData = await commonService.getExchangeRates(data);
        console.log("exchange rate", responseData.data);
        if (responseData.data.status_code === 200) {
          this.cal_by = "P";
          this.convertData = responseData.data.data[0];
          console.log("convertData", this.convertData.payoutAmount);
          this.amountSection.finalSendAmount = parseFloat(
            this.convertData.transferAmount
          ).toFixed(2);
          this.amountSection.sendAmount = parseFloat(
            this.convertData.transferAmount
          ).toFixed(2);
          this.isTransSummary = false;
          this.exchangeData = responseData.data.data[0];
        } else {
          this.cal_by = "";
          if (!this.is_partner) {
            this.alertMsg = {
              status: true,
              text:
                responseData.data.status_code +
                ": " +
                responseData.data.message,
              color: "warning",
              type: "warning",
              timeout: 2,
              key: Date.now(),
            };
          }
          this.isTransSummary = false;
          this.exchangeData = [];
          console.log("Evolet Send", this.amountSection.sendAmount);
          this.amountSection.sendAmount = "";
        }
      } catch (e) {
        this.cal_by = "";
        this.isTransSummary = false;
        console.log("Evolet Send", this.amountSection.sendAmount);
        this.amountSection.sendAmount = "";
        if (!this.is_partner) {
          this.alertMsg = {
            status: true,
            text: "Entered amount is not support to proceed transaction.",
            color: "warning",
            type: "warning",
            timeout: 2,
            key: Date.now(),
          };
        }

        console.log(e);
        this.exchangeData = [];
      }
    },
    getpaymode(val) {
      if (val) {
        //to map the payment mode while creatiing bene
        this.$store.state.selctedPayMode = val;
        if (val != this.BenePaymode) {
          //if payment mode changes recipient should select
          this.$store.state.data = {};
        }
      }
    },
    onClick1Week(e) {
      e.preventDefault();
      this.no_of_days = 7;
      this.getExchangeRate();
    },
    async getExchangeRate(country_code) {
      try {
        const responseData = await commonService.getgraphData({
          country: country_code || "",
          no_of_days: "7",
          partner_code: "QQPAY",
        });
        if (responseData.data.status_code === 200) {
          console.log("getExchangeRate22", responseData.data.data);
          this.exchange_rate = responseData.data.data;
          this.isKey = getspecifiedDate(new Date(), this.no_of_days).getTime();
          this.series[0].data =
            responseData.data.data.length > 0
              ? responseData.data.data.map((e) => {
                  return [new Date(e.created_on).getTime(), e.exchange_rate];
                })
              : [];
          this.$store.state.data;
        }
      } catch (e) {
        return e;
      }
    },
    //to get the payment modes for selcted country
    async getPaymentMode(country_name) {
      this.Loadsendmoney = true;
      try {
        const responseData = await commonService.getpaymentModeByCntry({
          country_code: country_name,
        });
        if (responseData.status === 200) {
          this.Loadsendmoney = false;
          this.paymentList = responseData.data.data.map((ele) => {
            return {
              value: ele.value,
              data: ele.value_code,
            };
          });
          const tempData = this.paymentList.find(
            (e) => e.value === this.amountSection.paymentMode.value
          );
          const defaultPaymentMode =
            this.paymentList.find((ele) => ele.data === "B") ||
            this.paymentList[0];

          if (!defaultPaymentMode) {
            this.amountSection.paymentMode = {};
            return;
          }

          this.amountSection.paymentMode = {
            data: defaultPaymentMode.data,
            value: defaultPaymentMode.value,
          };

          this.getExchangefee("C", this.amountSection.sendAmount, "");
          this.selected_service_charge = tempData;
        } else {
          this.Loadsendmoney = false;
        }
      } catch (e) {
        this.Loadsendmoney = false;
        console.log(e);
      }
    },
    //to get list of countries
    async getCountryList() {
      this.Loadsendmoney = true;
      try {
        const responseData = await commonService.getBeneCountryList();
        if (responseData.data.status_code === 200) {
          this.Loadsendmoney = false;
          responseData.data.data.map((i) => {
            this.country_list.push({
              text: i.currency_code,
              avatar: i.iso_alpha3,
              name: i.country_name,
            });
          });
          this.selected_country = {
            text: this.country_list[0].text,
            avatar: this.country_list[0].avatar,
            name: this.country_list[0].name,
            country_code: this.country_list[0].avatar,
          };
          this.selected_flag = this.country_list[0].avatar;
          this.target_currency = this.country_list[0].text;
        } else {
          this.Loadsendmoney = false;
        }

        console.log("countrys", responseData);
      } catch (e) {
        console.error(e);
        this.CountryList = [];
      }
    },
    //to get the exchange rates
    async getCountryExchangeRate() {
      this.Loadsendmoney = true;
      try {
        const responseData = await commonService.getFxRates({
          send_country: this.country_info.iso_alpha3,
          user_type: this.selected_user_Type,
        });
        if (responseData.data.status_code === 200) {
          this.Loadsendmoney = false;
          this.Loadsendmoney = false;
          responseData.data.data.map((i) => {
            console.log("i", i);
            this.country_obj.push(i);
          });
        } else {
          this.Loadsendmoney = false;
        }

        console.log("countrys", responseData);
      } catch (e) {
        console.error(e);
      }
    },

    async onClickNext() {
      // const valid = this.$refs.amountsection.validate();
      const valid = true;
      let tempData = this.paymentList.find(
        (e) => e.value === this.amountSection.paymentMode.value
      );
      if (
        valid &&
        this.exchangeData &&
        Math.floor(this.exchangeData.payoutAmount) ===
          Math.floor(this.amountSection.receiveAmount)
      ) {
        console.log(
          "this.convertData",
          Math.floor(this.amountSection.receiveAmount)
        );
        this.$emit("onNextClick", {
          transactionDetails: {
            amountSection: this.amountSection,
            selected_service_charge: tempData,
            exchange_rate: this.exchange_rate,
            target_currency: this.target_currency,
            selected_country: this.selected_country,
            country_name: this.recieving_cntry,
            base_currency: this.base_currency,
            convertData: this.convertData,
            exchangeData: this.exchangeData,
            cal_by: this.cal_by,
            policy_number: this.policy_number,
          },
        });
        this.$store.state.paymodeCountry = {
          paymode: this.amountSection.paymentMode.data
            ? this.amountSection.paymentMode.data
            : this.amountSection.paymentMode,
          country: this.selectedCountryDetails,
        };
        console.log("paymode", this.$store.state.paymodeCountry);
      } else {
        this.alertMsg = {
          status: true,
          text: "The transaction details are not support.Kindly check and try again.",
          color: "warning",
          type: "warning",
          timeout: 2,
          key: Date.now(),
        };
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/global.scss";

.form-inputs {
  display: inline-flex !important;
  flex-direction: column !important;
  padding: 1rem !important;
  margin: 2px 0px 2px 0px !important;
}
.amountsection {
  display: flex;
  justify-content: space-around;
}
.fixed-width {
  width: 24px !important;
  height: 24px !important;
}
.normal-flag {
  margin: 0px;
}
.v-text-field {
  padding-top: 0px;
  margin: 0px 6px;
}
.v-application--is-ltr .v-text-field .v-input__prepend-inner {
  padding-top: 0px !important;
}
.v-input__prepend-inner {
  display: flex;
  justify-content: center;
  align-items: center !important;
  min-height: 56px !important;
  border-right: 1px solid rgba(0, 0, 0, 0.42);
  margin: 0px !important;
  padding-top: 0px !important;

  margin-right: 5px !important;
  color: gray;
}
.v-input__prepend-inner .v-input {
  font-size: 24px !important;
  padding-left: 2px;
}

.v-input__slot {
  padding-left: 5px !important;
}
.v-grap-v-btn {
  box-shadow: none !important;
  background-color: transparent !important;
}
.v-grap-text {
  font-size: 23px !important;
  color: $lightgrey !important;
}
.custome-label-text {
  font-size: 0.8rem;
  color: gray;
  font-weight: bold !important;
}

.v-custome-icon .v-icon {
  color: gray !important;
  font-size: 16px !important;
  font-weight: bold !important;
}
.v-custome-icon {
  background-color: #ffff;
  display: flex;
  align-items: center;
  margin: auto;
  margin-left: auto;
  margin-right: -24px;
}
// .fixed-height-div {
//   min-height: fit-content !important;
// }
.custome-text-field .v-text-field__slot {
  font-size: 20px !important;
}
.custome-slect-prepend .v-input__slot .v-select__slot .v-select__selections {
  font-size: 16px !important;
  color: gray !important;
  padding-right: 0px !important;
}

.custome-text-field .v-input__slot {
  padding-right: 0px !important;
}
.custome-text-field .v-messages__wrapper {
  font-weight: bold;
}

.custome-slect-prepend .v-input__slot .v-select__slot label {
  color: gray !important;
}
.card-heading {
  display: flex;
  justify-content: center;
  font-size: 24px;
  background-color: $secondary;
  margin-bottom: 12px;
  padding: 8px;
  font-weight: 700;
  color: white;
  max-height: 43px;
}
.apex-div {
  margin-bottom: 10px !important;
}

.light-gray {
  color: rgba(50, 48, 48, 0.6);
  font-weight: 700;
}
.v-application--is-ltr .v-text-field .v-input__append-inner,
.v-application--is-rtl .v-text-field .v-input__prepend-inner {
  padding-left: 0px !important;
}
.font {
  font-size: 15px;
  font-weight: 800;
}
</style>
